import type { CoreStoreType } from '../../store/CoreStore';

import type { ICrossOriginCommunicator, OutgoingInfo } from './types';

export class CrossOriginCommunicationController {
  private readonly handleIncomingMessage = this.processIncomingMessage.bind(this);

  private communicators: ICrossOriginCommunicator[];
  private store: CoreStoreType;

  constructor() {
    this.communicators = [];
    this.store = {} as CoreStoreType;
  }

  close(): void {
    window.removeEventListener('message', this.handleIncomingMessage);
  }

  connect(): void {
    window.addEventListener('message', this.handleIncomingMessage);
  }

  dispatch(message: unknown, info?: OutgoingInfo): void {
    this.communicators.forEach((communicator) => communicator.send(message, this.store, info));
  }

  setCommunicator(communicator: ICrossOriginCommunicator): void {
    this.communicators.push(communicator);
  }

  setCommunicators(communicators: ICrossOriginCommunicator[]): void {
    this.communicators = communicators;
  }

  setStore(store: CoreStoreType): void {
    this.store = store;
  }

  private processIncomingMessage(event: MessageEvent): void {
    this.communicators.forEach((communicator) => communicator.process(event, this.store));
  }
}
